import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout';
import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import Delete from '../Delete/Delete';
import Drp_ProductGroup from '../ProductGroup/Drp_Group';
import Drp_ProductParentGroup from '../ProductGroup/Drp_Group';
import Auto_Product from '../Product/Auto_Product';
import Drp_StoreRoom from '../StoreRoom/Drp_StoreRoom';
import moment from 'moment-jalaali';
import DatePicker from 'react-datepicker2';
import PN from "persian-number";



const CardexCountReportIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    const rowKey = 'id';
    let navigate = useNavigate();
    const DeleteRef = useRef()
    const ProductRef = useRef()
    const GroupRef = useRef()
    const StoreRef = useRef()
    const ParentGroupRef = useRef()
    const [List, setList] = useState([]);
    const [FiscalYearId, setFiscalYearId] = useState(localStorage.getItem("FiscalYearId"));
    const [GroupId, setGroupId] = useState("-1");
    const [GroupParentId, setGroupParentId] = useState("-1");
    const [ProductTitle, setProductTitle] = useState('');
    const [ProductId, setProductId] = useState(General.GuidEmpty());
    const [StoreRoomId, setStoreRoomId] = useState(-1);
    const [BeginDate, setBeginDate] = useState(moment(new Date()));
    const [EndDate, setEndDate] = useState(moment(new Date()));
    //#region Tabe Setting
    const [sortColumn, setSortColumn] = React.useState();
    const [sortType, setSortType] = React.useState();
    const [loading, setLoading] = React.useState(false)
    const CompactCell = props => <rsuite.Table.Cell {...props} style={{ padding: 4 }} />;
    const CompactHeaderCell = props => <rsuite.Table.HeaderCell {...props} style={{ padding: 4 }} />;
    const defaultColumns = [
        {
            key: 'row',
            label: '#',
            fixed: true,
            sortable: true,
            width: 50,
            defaultOn: true

        },
        {
            key: 'Code',
            label: 'رسید / حواله',
            fullText: true,
            sortable: true,
            fixed: true,
            width: 100,
            defaultOn: true

        },
        {
            key: 'StoreRoom',
            label: 'انبار',
            fullText: true,
            sortable: true,
            fixed: true,
            width: 100,
            defaultOn: true

        },
        {
            key: 'Product',
            label: 'محصول',
            fixed: true,
            fullText: true,
            resizable: true,
            sortable: true,
            flexGrow: 1,
            defaultOn: true

        },
        {
            key: 'ProductIdentityNo',
            label: 'شناسه محصول',
            fixed: true,
            fullText: true,
            resizable: true,
            sortable: true,
            flexGrow: 1,
            defaultOn: true

        },
        {
            key: 'InsertDateTime',
            label: ' تاریخ ثبت',
            fullText: true,
            resizable: true,
            sortable: true,
            width: 100,
            defaultOn: true

        },
        {
            key: 'ConfirmDateTime',
            label: ' تاریخ تایید',
            fullText: true,
            resizable: true,
            sortable: true,
            width: 100,
            defaultOn: true

        },

        {
            key: 'InputCount',
            label: 'تعداد ورود',
            fullText: true,
            resizable: true,
            sortable: true,
            width: 100,
            defaultOn: true

        },
        {
            key: 'OutputCount',
            label: 'تعداد خروج',
            fullText: true,
            resizable: true,
            sortable: true,
            width: 100,
            defaultOn: true

        }
        ,
        {
            key: 'BeforPhysicalCount',
            label: 'تعداد فیزیکی قبل',
            fullText: true,
            resizable: true,
            sortable: true,
            width: 100,
            defaultOn: true

        },
        {
            key: 'NextPhysicalCount',
            label: 'تعداد فیزیکی',
            fullText: true,
            resizable: true,
            sortable: true,
            width: 100,
            defaultOn: true

        },
        {
            key: 'BeforSaleCount',
            label: 'تعداد قابل فروش قبل',
            fullText: true,
            resizable: true,
            sortable: true,
            width: 100,
            defaultOn: true

        },

        {
            key: 'NextSaleCount',
            label: 'تعداد قابل فروش',
            fullText: true,
            resizable: true,
            sortable: true,
            width: 100,
            defaultOn: true

        },

        {
            key: 'Price',
            label: 'قیمت واحد',
            fullText: true,
            resizable: true,
            sortable: true,
            width: 100,
            defaultOn: true
        },
        {
            key: 'DiscountPrice',
            label: 'تخفیف واحد',
            fullText: true,
            resizable: true,
            sortable: true,
            width: 100,
            defaultOn: false
        },
        {
            key: 'Tax',
            label: 'مالیات واحد',
            fullText: true,
            resizable: true,
            sortable: true,
            width: 100,
            defaultOn: false
        }
        ,
        {
            key: 'TotalPrice',
            label: 'قیمت کل',
            fullText: true,
            resizable: true,
            sortable: true,
            width: 100,
            defaultOn: false
        }
        ,
        {
            key: 'IsConfirm',
            label: 'وضعیت',
            fullText: true,
            resizable: true,
            sortable: true,
            width: 100,
            defaultOn: false
        }
    ];

    const handleSortColumn = (sortColumn, sortType) => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setSortColumn(sortColumn);
            setSortType(sortType);
        }, 500);
    };
    const handleChangeLimit = dataKey => {
        setPage(1);
        setLimit(dataKey);
    };


    const [compact, setCompact] = React.useState(true);
    const [columnKeys, setColumnKeys] = React.useState(defaultColumns.map(column => column.key));

    const columns = defaultColumns.filter(column => columnKeys.some(key => key === column.key));
    const CustomCell = compact ? CompactCell : rsuite.Table.Cell;
    const CustomHeaderCell = compact ? CompactHeaderCell : rsuite.Table.HeaderCell;
    const [limit, setLimit] = React.useState(10);
    const [page, setPage] = React.useState(1);
    //#endregion
    //#endregion



    const Product_Select = (e) => {
        setProductId(e.split("|")[0])
        setProductTitle(e.split("|")[1])
    }

    const Product_Change = (e) => {
        setProductId(General.GuidEmpty())
        if (e.split("|").length > 1) {
            setProductTitle(e.split("|")[1]);
            setProductId(e.split("|")[0])
            return;
        }
        setProductTitle(e);
        ProductRef.current.Bind(GroupParentId, GroupId, e)

    }

    const BeginDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setBeginDate(moment(m, 'jYYYY/jMM/jDD'));
    }

    const EndDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setEndDate(moment(m, 'jYYYY/jMM/jDD'));
    }

    const Parent_Change = (value) => {
        setGroupParentId(value);
        setProductId(General.GuidEmpty());
        setProductTitle("");
        setGroupId("-1");
        GroupRef.current.BindGroupByParentId(0, value);
        ProductRef.current.Bind(value, -1, '')
    }

    const Group_Change = (value) => {
        setGroupId(value);
        setProductId(General.GuidEmpty());
        setProductTitle("");
        ProductRef.current.Bind(GroupParentId, value, '')
    }

    //#region Methods


    const Search = () => {
        trackPromise(
            fetch(General.ApiRoute() + '/StoreRoomReport/Count_CardexReport', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'BeginDate': BeginDate != null ? moment(BeginDate.format()).format("jYYYY/jMM/jDD") : "",
                    'EndDate': EndDate != null ? moment(EndDate.format()).format("jYYYY/jMM/jDD") : "",
                    'ProductId': ProductId,
                    'GroupId': GroupId,
                    'GroupParentId': GroupParentId,
                    'FiscalYearId': FiscalYearId,
                    'StoreRoomId': StoreRoomId,
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    var tmp = []

                    for (var i = 0; i < result.length; i++) {
                        tmp.push({
                            row: i + 1,
                            Price: PN.sliceNumber(result[i].price),
                            Tax: PN.sliceNumber(result[i].tax),
                            TotalPrice: PN.sliceNumber(result[i].totalPrice),
                            DiscountPrice: PN.sliceNumber(result[i].discountPrice),
                            BeforPhysicalCount: result[i].beforPhysicalCount,
                            BeforSaleCount: result[i].beforSaleCount,
                            NextPhysicalCount: result[i].nextPhysicalCount,
                            NextSaleCount: result[i].nextSaleCount,
                            InputCount: result[i].draftType == "Recipt" ? result[i].count : 0,
                            OutputCount: result[i].draftType != "Recipt" ? result[i].count : 0,
                            Product: result[i].product,
                            ProductIdentityNo: result[i].productIdentityNo,
                            StoreRoom: result[i].storeRoom,
                            InsertDateTime: result[i].insertDate + " " + result[i].insertTime,
                            ConfirmDateTime: result[i].confirmDate + " " + result[i].confirmTime,
                            Code: result[i].headerCode,
                            InsertUser: result[i].insertUser,
                            IsConfirm: result[i].confirmId != General.GuidEmpty() ? "تایید شده" : "تایید نشده",

                        })
                    }
                    setList(tmp)
                })
        )
    }






    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 15);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        Search();
                        ParentGroupRef.current.BindGroupByParentId(-1, 0);
                        StoreRef.current.Bind(-1);
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }




    useEffect(() => {
        CheckPermission();
        document.title = "کاردکس کالا (تعدادی) ";
    }, [])
    //#endregion







    return (

        <Layout title=" کاردکس کالا (تعدادی)">


            <div className="h-100">
                <rsuite.Panel className="bg-white ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={Search}>  جستجو</rsuite.Button>

                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />

                    <rsuite.Row >

                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                            <label>انبار</label>
                            <Drp_StoreRoom className='rs-input' value={StoreRoomId} onChange={(e) => setStoreRoomId(e)} ref={StoreRef} />
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                            <label> از تاریخ </label>
                            <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={BeginDate} onChange={BeginDate_Change} />

                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                            <label>تا تاریخ </label>
                            <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={EndDate} onChange={EndDate_Change} />
                        </rsuite.Col>
                    </rsuite.Row>
                    <rsuite.Row>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                            <label>گروه   </label>
                            <Drp_ProductParentGroup className="rs-input" value={GroupParentId} onChange={Parent_Change} ref={ParentGroupRef} />
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                            <label>زیر گروه   </label>
                            <Drp_ProductGroup className="rs-input" value={GroupId} onChange={Group_Change} ref={GroupRef} />
                        </rsuite.Col>

                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                            <label> محصول   </label>
                            <Auto_Product className="rs-input" value={ProductTitle} onChange={Product_Change} onSelect={Product_Select} ref={ProductRef} />
                        </rsuite.Col>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <label> فیلتر   </label>
                            <rsuite.VStack spacing={16}>

                                <rsuite.TagPicker
                                    data={defaultColumns}
                                    labelKey="label"
                                    valueKey="key"
                                    value={columnKeys}
                                    onChange={setColumnKeys}
                                    cleanable={false}
                                    className='Font10 w-100p'
                                />
                            </rsuite.VStack>
                        </rsuite.Col>
                    </rsuite.Row>

                    <div className="h-90 p-1">
                        <div className="h-100-y">
                            <rsuite.Panel className="bg-white mt-2">


                                <rsuite.Table


                                    height={400}
                                    // data={List}
                                    loading={loading}
                                    data={List.sort((a, b) => {
                                        let x = a[sortColumn];
                                        let y = b[sortColumn];
                                        if (typeof x === 'string') {
                                            x = x.charCodeAt();
                                        }
                                        if (typeof y === 'string') {
                                            y = y.charCodeAt();
                                        }
                                        if (sortType === 'asc') {
                                            return x - y;
                                        } else {
                                            return y - x;
                                        }
                                    }).filter((v, i) => {
                                        const start = limit * (page - 1);
                                        const end = start + limit;
                                        return i >= start && i < end;
                                    })}
                                    sortColumn={sortColumn}
                                    sortType={sortType}
                                    onSortColumn={handleSortColumn}


                                >
                                    {columns.map(column => {
                                        const { key, label, ...rest } = column;
                                        return (
                                            <rsuite.Table.Column {...rest} key={key}>
                                                <CustomHeaderCell>{label}</CustomHeaderCell>
                                                <CustomCell dataKey={key} />
                                            </rsuite.Table.Column>
                                        );
                                    })}


                                </rsuite.Table>

                                <div style={{ paddingTop: 20 }}>
                                    <rsuite.Pagination
                                        prev
                                        next
                                        first
                                        last
                                        ellipsis
                                        boundaryLinks
                                        maxButtons={5}
                                        size="xs"
                                        layout={['total', '-', 'limit', '|', 'pager', 'skip']}
                                        total={List.length}
                                        limitOptions={[5, 10, 30, 50, 100]}
                                        limit={limit}
                                        activePage={page}
                                        onChangePage={setPage}
                                        onChangeLimit={handleChangeLimit}
                                    />
                                </div>
                            </rsuite.Panel>

                        </div>
                    </div>

                </rsuite.Panel >
            </div >



        </Layout >


    )
}

export default CardexCountReportIndex;